import { createFileRoute, redirect } from "@tanstack/react-router";
import { InventoryCountDetailPage } from "@/features/inventory-count/pages/InventoryCountDetailPage";

export const Route = createFileRoute("/admin/inventory-count/$id/detail")({
  // Keep the active tab in the URL (?tab=) so refresh + link-sharing preserve it.
  validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["inventory_count.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryCountDetailPage,
});
